import * as React from 'react';
import { Tooltip } from '@cian/ui-kit';

import { EPromoType } from '../../../../types/newBuldings/promo';
import { PROMO_ICONS_MAP } from './constants';
import * as styles from './Promo.css';

export interface IPromoProps {
  newBuildingLabel: string;
  onClick?: (event: React.MouseEvent) => void;
  onHover?: (event: React.MouseEvent) => void;
  promoType: EPromoType;
  url: string;
}

export function Promo({ newBuildingLabel, promoType, url, onClick, onHover }: IPromoProps) {
  const iconSrc = PROMO_ICONS_MAP.get(promoType);

  if (!iconSrc) {
    return null;
  }

  return (
    <Tooltip title={newBuildingLabel} placement="bottom-start">
      <a
        className={styles['promo-link']}
        href={url}
        target="_blank"
        rel="noreferrer"
        onClick={onClick}
        onMouseEnter={onHover}
      >
        <img className={styles['promo-icon']} src={iconSrc} />
      </a>
    </Tooltip>
  );
}
